'use client';

import * as React from 'react';

import { useAuth } from '@dashboard/context/AuthContext';
import Meta from '@/dashboard/components/Meta';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@dashboard/components/ui/sidebar';
import { Separator } from '@dashboard/components/ui/separator';
import { AdminSidebar } from '../components/AdminSidebar';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return <div>Authenticating...</div>;
  }

  return (
    <>
      <Meta
        noIndex
        meta={{
          title: 'Admin',
        }}
      />

      <SidebarProvider defaultOpen={true}>
        <AdminSidebar />
        <SidebarInset>
          {/* Header with sidebar trigger */}
          <header className="flex h-12 shrink-0 items-center gap-2 border-b border-gray-200 dark:border-border px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <span className="font-medium text-gray-darkest text-sm">Admin</span>
          </header>

          {/* Main content area */}
          <main className="flex-1 overflow-auto p-4 lg:p-6">{children}</main>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
};

export default AdminLayout;
